import { Injectable } from '@angular/core';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { CommonUtils } from 'src/shared/utils/common-utils';

@Injectable({
  providedIn: "root",
})
export class NotificationsRedirectService {

  constructor(
    private navCtrl: CustomNavController,
    private utils: CommonUtils
  ) {}

  public static readonly PAGES = [
    'no_page',
    'chat_page',
    'homekeeper_job_page',
    'customer_page',
    'proposal_page',
    'opportunities_page',
    'job_delegation_page',
    'payouts_page',
    'dispute_page',
    'feedback_page',
    'parking_reimbursement_page',
    'team_page',
  ];

  async redirectToPage(pageData: {name: string, data?: any, [key: string]: any}) {
    try {
      const pageName = pageData.name.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
      if (typeof this[pageName] === 'function') {
        await this[pageName](pageData.data);
      }
    } catch (err) {
      this.utils.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
      this.homePage();
    }
  }

  noPage() {
    this.homePage();
  }

  // eg.
  // data: { chat_room_key: 'customer_account_id-123,team_id-456', chat_room_type: 'account' }
  // data: { chat_room_key: 'concierge,homekeeper_id-48619', chat_room_type: 'concierge_homekeeper' }
  async chatPage(data) {
    if (data && data.chat_room_type === 'concierge_homekeeper' && data.chat_room_key) {
      if (data.chat_room_key) {
        this.navCtrl.navigateForward(`client-messages/${data.chat_room_key}`, {
          customBackRoute: 'dashboard',
          fromNotification: true,
          chatRoomKey: data.chat_room_key,
        });
        return;
      }
    }

    // Default behavior for other chat types
    this.navCtrl.navigateForward('messages', {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: { job_id: 123 }
  async homekeeperJobPage(data) {
    this.navCtrl.navigateForward(`jobs/${data.job_id}`, {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: { customer_id: 123 }
  async customerPage(data) {
    this.navCtrl.navigateForward(`private-client/${data.customer_id}`, {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: { proposal_id: 123 }
  async proposalPage(data) {
    this.navCtrl.navigateForward(`proposal/${data.proposal_id}`, {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: {}
  async opportunitiesPage() {
    // await this.cleaningOportunities.changeStatus('opened', id);
    localStorage.removeItem('jobRequestsStartDate');
    localStorage.removeItem('jobRequestsEndDate');
    localStorage.setItem('jobRequestsStringValue', 'all_time');
    this.navCtrl.navigateRoot('add', {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: {}
  async jobDelegationPage(data) {
    this.navCtrl.navigateForward('add', {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: {}
  async payoutsPage(data) {
    this.navCtrl.navigateForward(`payouts`, {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: { dispute_id: 123 }
  async disputePage(data) {
    this.navCtrl.navigateForward(`dispute-resolution/${data.dispute_id}`, {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: {}
  async feedbackPage(data) {
    this.navCtrl.navigateForward('feedback', {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: { job_id: 123 }
  async parkingReimbursementPage(data) {
    this.navCtrl.navigateForward(`parking-reimbursement/${data.job_id}`, {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  // eg.
  // data: { team_id: 123 }
  async teamPage(data) {
    this.navCtrl.navigateForward(`team/${data.team_id}`, {
      customBackRoute: 'dashboard',
      fromNotification: true
    });
  }

  private homePage(): Promise<any> {
    return this.navCtrl.navigateRoot('');
  }
}
